<template>
  <div class="appointment-reminder">
    <div class="appointment-content">
      <h1>{{ appointment.type }}</h1>

      <div
        v-if="appointment.time"
        class="time"
      >
        <v-icon>
          mdi-clock-outline
        </v-icon>

        <p>{{ appointment.time }}</p>
      </div>
    </div>
  </div>
</template>

<script>
const formatTimes = times => {
    if (!times) return null;

    // The times are provided as an array of strings:
    const time = Number(times[0]);

    if (time > 12) return `${time}pm`;

    return `${time}am`;
};

export default {
    name: 'Appointment',
    props: {
        event: {
            type: Object,
            default: () => ({
                id: '0',
                jobName: 'unknown',
                description: 'unknown',
                calendarInfo: {
                    schedule: {
                        dayOfMonth: [0],
                        month: [0],
                        times: ['13'],
                        year: [2022],
                    },
                },
            }),
        },
    },

    computed: {
        appointment() {
            return {
                id: this.event.id,
                type: this.event.jobName,
                time: formatTimes(this.event.calendarInfo.schedule.times),
                date: this.event.calendarInfo.schedule.dayOfMonth,
            };
        },
    },
};


</script>


<style lang="scss" scoped>
    .appointment-reminder {
        position: relative;

        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        max-width: 90%;

        border-radius: 4px;
        background: #B2E6F6;
        margin-bottom: 12px;
        padding: 12px;
}
    .appointment-content {
        max-height: 50px;
        border-left: 2px solid #95D0E2;

    }

   .v-icon {
    position: absolute;
    color: #79A9B8;

    font-size: 16px;
    margin-left: 10px;
}

    h1 {
        font-size: 14px;
        font-weight: 400;
        color: #3B3B3B;
        margin-left: 10px;
    }

    p {
        font-size: 13px;
        font-weight: 400;
        color: #3B3B3B;
        margin-left: 32px;
        margin-top: 5px;
    }
</style>
